import type { StylesConfig } from "react-select";

export const crudSelectStyles = (
  hasError: boolean
): StylesConfig<any, boolean> => ({
  clearIndicator: (base) => ({
    ...base,
    color: "#ba78de",
    backgroundColor: "#f4f2f2",
    borderRadius: "0.75rem",
    padding: "4px",
    marginRight: "0.3rem",
    "&:hover": {
      color: "#8c1ec8",
    },
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: hasError ? "#d32f2f" : "",
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    margin: "0",
    padding: "0",
  }),
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "0.75rem",
    borderColor: hasError ? "#d32f2f" : "rgba(0, 0, 0, 0.23)",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: "0.75rem",
    borderRadius: "0.75rem",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#ba78de",
    backgroundColor: "#f4f2f2",
    borderRadius: "0.75rem",
    padding: "4px",
    margin: "0 0.3rem",
    "&:hover": {
      color: "#8c1ec8",
    },
  }),
  loadingIndicator: (base) => ({
    ...base,
    color: "#ba78de",
  }),
  menuPortal: (base) => ({
    ...base,
    borderRadius: "0.75rem",
    zIndex: 9999,
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? undefined
      : isSelected
      ? "#f4f2f2"
      : isFocused
      ? "#a34bd3"
      : undefined,
    color: isDisabled
      ? "#bcbcbc"
      : isSelected
      ? "black"
      : isFocused
      ? "white"
      : undefined,
    cursor: isDisabled ? "not-allowed" : "default",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#8c1ec8",
    borderRadius: "0.75rem",
    color: "white",
    padding: "0.25rem 0.5rem 0.25rem 0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.25rem",
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: "white",
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "0.75rem",
    color: "#8c1ec8",
    backgroundColor: "white",
    padding: "0.025rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ":hover": {
      color: "#ff1744",
    },
  }),
});
